import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import Reveal from "./Reveal";
import { FAQS } from "../data/data";

function FAQItem({ item, isOpen, onToggle }) {
  return (
    <div className="border-b" style={{ borderColor: "rgba(255,255,255,0.1)" }}>
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-4 py-5 text-left"
      >
        <span style={{ fontFamily: "Fraunces, serif" }} className="text-lg">
          {item.q}
        </span>
        <ChevronDown
          size={18}
          style={{
            flexShrink: 0,
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
            color: "#1E9AFF",
          }}
        />
      </button>
      <div
        style={{
          maxHeight: isOpen ? "200px" : "0px",
          opacity: isOpen ? 1 : 0,
          overflow: "hidden",
          transition: "max-height 0.35s ease, opacity 0.25s ease",
        }}
      >
        <p className="text-sm opacity-70 leading-relaxed pb-5 pr-8">{item.a}</p>
      </div>
    </div>
  );
}

export function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-24 px-6 md:px-10">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3 text-center" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
            Good To Know
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl mb-12 text-center">
            Frequently asked questions
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div>
            {FAQS.map((item, i) => (
              <FAQItem
                key={item.q}
                item={item}
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default FAQ;
